import { downgradeInjectable } from '@angular/upgrade/static';
import { Logger } from '@mode/shared/contract-common';
import { HelpDocsService, LocalStorageService } from '@mode/shared/util-js';
import {
  CreateNewReportObservabilityService,
  ObservabilityService,
  PerformanceService,
  ReportCreationObservabilityService,
  ViewReportObservabilityService,
} from '@mode/shared/util-observability';
import * as angular from 'angular';

export const DowngradedSharedUtilJsModule = angular
  .module('downgraded-shared-util-js', [])
  .service('ViewReportObservabilityService', downgradeInjectable(ViewReportObservabilityService))
  .service('CreateNewReportObservabilityService', downgradeInjectable(CreateNewReportObservabilityService))
  .service('ReportCreationObservabilityService', downgradeInjectable(ReportCreationObservabilityService))
  .service('LocalStorageService', downgradeInjectable(LocalStorageService))
  .service('ObservabilityService', downgradeInjectable(ObservabilityService))
  .service('PerformanceService', downgradeInjectable(PerformanceService))
  .service('$log', downgradeInjectable(Logger))
  .service('HelpDocsService', downgradeInjectable(HelpDocsService)).name;
